// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderImportant_wrapper__qWhZP","row":"OrderImportant_row__K9USI","checkbox":"OrderImportant_checkbox__m42FA"};